// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"141d864c","765":"c1d63905","778":"e1d11677","821":"0cec88ed","958":"31814f89"}[chunkId] + ".chunk.js";
};